import { render, staticRenderFns } from "./CupLeague.vue?vue&type=template&id=4d0da298&scoped=true&"
import script from "./CupLeague.vue?vue&type=script&lang=js&"
export * from "./CupLeague.vue?vue&type=script&lang=js&"
import style0 from "./CupLeague.vue?vue&type=style&index=0&id=4d0da298&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0da298",
  null
  
)

export default component.exports